import { ApiServices } from "../../services/api_services";
import { COREURL } from "../../constants/api_constants";
import { ROLES } from "../../base/constant";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetItemFromStorage } from "../../custom_hooks/useStorage";
import { LocalStorage } from "../../custom_hooks/localStorageKeys";
import axios from "axios";
import _ from "lodash";
import callChatService from "../../base/service/chatService";
import { CoreServices } from "../../base/service/apiServices";

const LoginUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);

const getAllUsers = createAsyncThunk("users/getAllUserList", async () => {
  return ApiServices.get(
    COREURL,
    `/get_user_list_by/${ROLES.OWNER_ROLE_ID},${ROLES.SUB_OWNER_ROLE_ID},${ROLES.ADMIN_ROLE_ID},${ROLES.SUPERVISOR_ROLE_ID},${ROLES.AGENT_ROLE_ID}`
  )
    .then((response) => {
      return response;
    })
    .catch((error) => error);
});

const getUserDetails = createAsyncThunk("users/getUserById", async (id: any) => {
  return ApiServices.get(COREURL, `/get_user_details_list/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => error);
});

const createUserDetails = createAsyncThunk("users/createUser", async (data: any) => {
  const bodyData = {};
  const body = { ...bodyData, ...data };
  return ApiServices.put(COREURL, "/update_user", body)
    .then((response: any) => response)
    .catch((error: any) => error);
});

const updateUserDetails = createAsyncThunk("users/updateUser", async (currentUserDetails: any) => {
  const bodyData = {
    add_skill: currentUserDetails.skill,
    chat: currentUserDetails.channelList.chat,
    email: currentUserDetails.channelList.email,
    emailId: currentUserDetails.wholeData.emailId,
    outBound_call: currentUserDetails.outBoundCall,
    report_to: currentUserDetails.reportTo.key,
    report_to_name: currentUserDetails.reportTo.value,
    routing_profile: currentUserDetails.routingProfile.key,
    routing_profile_name: currentUserDetails.routingProfile.value,
    sms: currentUserDetails.channelList.sms,
    socialMedia: currentUserDetails.channelList.socialMedia,
    voice: currentUserDetails.channelList.voice,
    chatLimit: currentUserDetails?.chatLimit ?? 0,
    domain_id: currentUserDetails?.domain_id,
    ext: currentUserDetails?.ext,
    primaryLanguage: currentUserDetails?.primaryLanguage,
    secondaryLanguage: currentUserDetails?.secondaryLanguage,
    inboundCall:currentUserDetails?.inboundCall,
    outboundCampaignCall:currentUserDetails?.outboundCampaignCall,
    is_outbound_campaign_specific_agent:currentUserDetails?.is_outbound_campaign_specific_agent,
  };
  callChatService.io.emit("updateRoutingProfile", bodyData);
  return ApiServices.put(COREURL, "/update_user", bodyData)

    .then((response) => response)
    .catch((error) => error);
});


const getChannelsAddOnList = createAsyncThunk("users/getChannels_addOnList", async () => {
  try {
    return axios.post("https://mysqlapi.worktual.co.uk/myaccount-mysql/v1/worktual/get_all_addon_list", { "company_id": LoginUserDetails?.companyId })
    .then((res: any) =>{
      if(res.data.status_code == 200 && res?.data?.users?.length > 0){
        return _.uniqBy(res?.data?.users[0], "addon_feature_name");
      }
    })
    .catch((error: any) => error);
  } catch (error) { console.log(error) }
});


export { getAllUsers, getUserDetails, updateUserDetails, createUserDetails ,getChannelsAddOnList};
